import { Currency, Percent, Price } from '@uniswap/sdk'
import React, { useContext } from 'react'
import { Text } from 'rebass'
import styled, { ThemeContext } from 'styled-components'
import { AutoColumn } from '../../components/Column'
import { AutoRow } from '../../components/Row'
import { ONE_BIPS } from '../../constants'
import { Field } from '../../state/mint/actions'
import { TYPE } from '../../theme'
import { useTranslation } from 'react-i18next'

export function PoolPriceBar({
  currencies,
  noLiquidity,
  poolTokenPercentage,
  price
}: {
  currencies: { [field in Field]?: Currency }
  noLiquidity?: boolean
  poolTokenPercentage?: Percent
  price?: Price
}) {




  const theme = useContext(ThemeContext)
  const { t } = useTranslation()
  return (
    <AutoColumn gap="md">
      <AutoRow justify="space-around" gap="4px">
        <AutoColumn justify="center">
          <SharePriceHead>{price?.toSignificant(6) ?? '-'}</SharePriceHead>
          <SharePriceHead>
            {currencies[Field.CURRENCY_B]?.symbol} {t('per')} {currencies[Field.CURRENCY_A]?.symbol}
          </SharePriceHead>
        </AutoColumn>
        <AutoColumn justify="center">
          <SharePriceHead>{price?.invert()?.toSignificant(6) ?? '-'}</SharePriceHead>
          <SharePriceHead>
            {currencies[Field.CURRENCY_A]?.symbol} {t('per')} {currencies[Field.CURRENCY_B]?.symbol}
          </SharePriceHead>
        </AutoColumn>
        <AutoColumn justify="center">
          <SharePriceHead>
            {noLiquidity && price
              ? '100'
              : (poolTokenPercentage?.lessThan(ONE_BIPS) ? '<0.01' : poolTokenPercentage?.toFixed(2)) ?? '0'}
            %
          </SharePriceHead>
          <SharePriceHead>
            {t('Share of Pool')}
          </SharePriceHead>
        </AutoColumn>
      </AutoRow>
    </AutoColumn>
  )
}
const SharePriceHead = styled.p`
  margin-bottom: 5px;
    color: #fff;
    font-size: 13px;
    line-height: 13px;
    white-space: nowrap;
    margin-top: 0px;
  `
